import {defineMessages, FormattedMessage} from 'react-intl';
import {Text} from 'src/v2/components/common/Text';
import {LinkTitleWrapper} from 'src/v2/components/screen/link/LinkTitleWrapper';

const messages = defineMessages({
  title: {
    id: 'crypto.payins.v2.heading.setup_title',
    description:
      'Header for the screen when saving a payment method for future usage',
    defaultMessage: 'Add payment method',
  },
});

export const SetupTitle = () => {
  return (
    <LinkTitleWrapper>
      <Text type="headline">
        <FormattedMessage {...messages.title} />
      </Text>
    </LinkTitleWrapper>
  );
};
